import React, { Component } from "react";
var IBMRequirementsData = require('../../data/requirements.json')
var jsonQuery = require('json-query')

class RequirementRationale extends Component {

    render() {
            return (
                <>
                {getRequirementRationale(this.props.reqid)}
                </>
            )    
        }
    }
    export default RequirementRationale
    
    function getRequirementRationale(reqid) {        
        var result = jsonQuery(reqid, {
            data: IBMRequirementsData
        })
    
        var retValue
        if(result.value){  // make sure result.value is not undefined/null
            
            // Replace /n carriage returns with <br/> breaks
            var formattedRationale = result.value.Rationale.split("\n").map(function(item, idx) {
                return (
                    <span key={idx}>
                        {item}
                        <br/>
                    </span>
                 )
            })

            retValue = <>
            <p style={{ paddingRight: "0px", fontSize: "16px", lineHeight:"1.5" }}>{formattedRationale}</p>
            <br/><br/>
            </>
        }else{
            retValue = <></>
        }
    
        return retValue
    
    }    




